var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useRef } from "react";
import { Icon } from "../../atoms/Icon/index";
import { ContentWrapper, CloseButton, LightBoxDialog, TopBar, Header } from "./styles";
import YU_COLOURS from "../../../styles/colours";
import styled from "styled-components";
import { BaseModal, MODAL_ID } from "./base/BaseModal";
export var ModalType;
(function (ModalType) {
    ModalType["small"] = "small";
    ModalType["medium"] = "medium";
    ModalType["large"] = "large";
})(ModalType || (ModalType = {}));
export var ModalDialog = function (_a) {
    var closeOnClickOutside = _a.closeOnClickOutside, primaryButton = _a.primaryButton, secondaryButton = _a.secondaryButton, showModal = _a.showModal, _b = _a.padding, padding = _b === void 0 ? "2.5rem" : _b, _c = _a.hideTopBar, hideTopBar = _c === void 0 ? false : _c, closeModal = _a.closeModal, type = _a.type, _d = _a.background, background = _d === void 0 ? YU_COLOURS.S310 : _d, children = _a.children;
    var initialFocusRef = useRef(null);
    return (React.createElement(BaseModal, { showModal: showModal, closeOnClickOutside: closeOnClickOutside, closeModal: closeModal },
        React.createElement(LightBoxDialog, { isVisible: showModal, open: showModal, hidden: !showModal, "aria-hidden": !showModal, id: MODAL_ID, "aria-label": MODAL_ID, "aria-modal": "true", role: "dialog", type: type, background: background },
            React.createElement(FlexColumnReverse, null,
                React.createElement(ContentWrapper, { padding: padding },
                    children,
                    primaryButton &&
                        React.cloneElement(primaryButton, {
                            ref: initialFocusRef,
                        }),
                    secondaryButton),
                hideTopBar ? (React.createElement(Header, null,
                    React.createElement(CloseButton, { onClick: closeModal, "aria-label": "close" },
                        React.createElement(Icon, { name: "exit", fill: YU_COLOURS.B1100 })))) : (React.createElement(TopBar, null,
                    React.createElement(CloseButton, { onClick: closeModal, "aria-label": "close" },
                        React.createElement(Icon, { name: "exit", fill: YU_COLOURS.white }))))))));
};
var FlexColumnReverse = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column-reverse;\n"], ["\n  display: flex;\n  flex-direction: column-reverse;\n"])));
var templateObject_1;
